import React from 'react';
import { MenuItem, Typography } from '@mui/material';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { useNavigate } from 'react-router-dom';

export type menuAccessToPrescriberType = {
    prescripteurId: number;
    prescriberPath: string;
};
const MenuAccessToPrescriber: React.FunctionComponent<menuAccessToPrescriberType> = function ({
    prescripteurId,
    prescriberPath = '/prescripteurs/liste',
}) {
    const navigate = useNavigate();

    const handlePrescriberLinkClick = () => {
        navigate(`${prescriberPath}/${prescripteurId}?prescriber-detail=resume`);
    };

    return (
        <MenuItem
            sx={{ gap: '4px' }}
            onClick={handlePrescriberLinkClick}
        >
            <FaOptionIcon
                icon={['fasl', 'user']}
                color="text.gris70"
            />
            <Typography sx={{ color: 'text.primary' }}>Accéder au prescripteur</Typography>
        </MenuItem>
    );
};

export default MenuAccessToPrescriber;
